module.exports = __webpack_public_path__ + "img/company.ce2c26c8.png";